module.exports = __webpack_public_path__ + "assets/images/02_c6be049fdf28b74b1693c1b29f2765c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-4/02.png
// module id = 250
// module chunks = 0